(function() {
	
	var Point = include("PIXI.Point", false) || include("createjs.Point", false),
		Rectangle = include("PIXI.Rectangle", false) || include("createjs.Rectangle", false);

	var Polygon = function(config, pointScale)
	{
		var pointScaleX, pointScaleY;
		if(pointScale)
		{
			if(pointScale instanceof Point || typeof pointScale.x == "number")
			{
				pointScaleX = pointScale.x;
				pointScaleY = pointScale.y;
			}
			else
				pointScaleX = pointScaleY = pointScale;
		}
		//check for undefined or 0
		if(!pointScaleX)
			pointScaleX = 1;
		if(!pointScaleY)
			pointScaleY = 1;
		var edges = this.edges = [];
		var points = this.points = [];
		this.isRectangle = false;
		/**
		 * Position of the polygon - Use setOrigin() to change the position of the polygon in
		 * world space.
		 * @property {Point} origin.
		 */
		this.origin = new Point();
		/**
		 * Rotation of polygon in degrees. This is used to keep track of current rotation in order
		 * to correctly rotate all points and edges. Do not set this yourself.
		 * @property {Number} _rotation
		 * @private
		 */
		this._rotation = 0;
		
		var pointList;
		if(Array.isArray(config))
			pointList = config;
		else if(config.points)
			pointList = config.points;
		else if(config.type == "rect")
		{
			pointList =
			[
				new Point(config.x, config.y),
				new Point(config.x + config.w, config.y),
				new Point(config.x + config.w, config.y + config.h),
				new Point(config.x, config.y + config.h)
			];
			this.isRectangle = true;
		}
		
		var prevPoint;
		//go through the points and set up points and edges
		var i, length, curPoint;
		for(i = 0, length = pointList.length; i < length; ++i)
		{
			var pointObj = pointList[i];
			curPoint = new Point(pointObj.x * pointScaleX, pointObj.y * pointScaleY);
			if(prevPoint)
			{
				edges.push(new Point(curPoint.x - prevPoint.x, curPoint.y - prevPoint.y));
			}
			points.push(curPoint);
			prevPoint = curPoint;
		}
		
		//add the final edge to connect the start to the end
		curPoint = points[0];
		edges.push(new Point(curPoint.x - prevPoint.x, curPoint.y - prevPoint.y));
		
		/** Axis Aligned Bounding Box - used for optimization. */
		this.aabb = new Rectangle();
		this.aabbIsDirty = false;
	};
	
	var p = Polygon.prototype;
	
	/**
	 * Scales the polygon by the spcified value.
	 * @method scale
	 * @param {Number} scaleVal The factor to scale the polygon by.
	 */
	p.scale = function(scaleVal)
	{
		var i, length, curPoint, prevP, edgePoint, points = this.points, edges = this.edges;
		for(i = 0, length = points.length; i < length; ++i)
		{
			curPoint = points[i];
			var xnew = curPoint.x * scaleVal;
			var ynew = curPoint.y * scaleVal;
			curPoint.x = xnew;
			curPoint.y = ynew;
			
			if(prevP)
			{
				edgePoint = edges[i - 1];
				edgePoint.x = xnew - prevP.x;
				edgePoint.y = ynew - prevP.y;
			}
			
			prevP = curPoint;
		}
		//do the final edge
		curPoint = points[0];
		edgePoint = edges[i - 1];
		edgePoint.x = curPoint.x - prevP.x;
		edgePoint.y = curPoint.y - prevP.y;
		
		this.aabbIsDirty = true;
	};
	
	/**
	* Rotation of polygon in degrees. Settings this modifies all points in the polygon.
	* @property {Number} rotation
	*/
	Object.defineProperty(p, "rotation", {
		get: function() { return this._rotation; },
		set: function(value)
		{
			//ensure that the rotation has changed and is a valid number
			if(value == this._rotation || value != value) return;
			var rotationDifference = (value - this._rotation) * Math.DEG_TO_RADS;
			this._rotation = value;
			var s = Math.sin(rotationDifference);
			var c = Math.cos(rotationDifference);
			var i, length, curPoint, prevP, edgePoint, points = this.points, edges = this.edges;
			for(i = 0, length = points.length; i < length; ++i)
			{
				curPoint = points[i];
				//counterclockwise angle - math standard, seems to be correct for our purposes
				var xnew = curPoint.x * c - curPoint.y * s;
				var ynew = curPoint.x * s + curPoint.y * c;
				/*
				//clockwise angle
				var xnew = p.x * c + p.y * s;
				var ynew = -p.x * s + p.y * c;
				*/
				curPoint.x = xnew;
				curPoint.y = ynew;
				
				if(prevP)
				{
					edgePoint = edges[i - 1];
					edgePoint.x = xnew - prevP.x;
					edgePoint.y = ynew - prevP.y;
				}

				prevP = curPoint;
			}
			//do the final edge
			curPoint = points[0];
			edgePoint = edges[i - 1];
			edgePoint.x = curPoint.x - prevP.x;
			edgePoint.y = curPoint.y - prevP.y;
			this.aabbIsDirty = true;
		}
	});
		
	p.calcAABB = function()
	{
		var xMin = Infinity;
		var xMax = -Infinity;
		var yMin = Infinity;
		var yMax = -Infinity;
		var points = this.points;
		for(var i = 0, length = points.length; i < length; ++i)
		{
			var curPoint = points[i];
			var x = curPoint.x;
			var y = curPoint.y;
			if(x < xMin)
				xMin = x;
			if(x > xMax)
				xMax = x;
			if(y < yMin)
				yMin = y;
			if(y > yMax)
				yMax = y;
		}
		var aabb = this.aabb;
		aabb.x = xMin + this.origin.x;
		aabb.y = yMin + this.origin.y;
		aabb.width = xMax - xMin;
		aabb.height = yMax - yMin;
	};
	
	p.setOrigin = function(x, y)
	{
		this.origin.x = x;
		this.origin.y = y;
		this.aabbIsDirty = true;
	};
	
	p.resetPositioning = function()
	{
		this.origin.x = this.origin.y = 0;
		this.rotation = 0;
		this.aabbIsDirty = true;
	};
	
	/**
	 * Determines if the polygon contains a given point.
	 * @param  {Number} x The x position to check for, in collision world space.
	 * @param  {Number} y The y position to check for, in collision world space.
	 * @return {Boolean} If the point is contained in the polygon.
	 */
	p.contains = function(x, y)
	{
		var inside = false;

		// use some raycasting to test hits
		// https://github.com/substack/point-in-polygon/blob/master/index.js
		var points = this.points;
		var length = points.length;
		
		var origin = this.origin;
		for(var i = 0, j = length - 1; i < length; j = i++)
		{
			var p1 = points[i], p2 = points[j];
			var xi = p1.x + origin.x, yi = p1.y + origin.y,
				xj = p2.x + origin.x, yj = p2.y + origin.y;
			
			intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);

			if(intersect) inside = !inside;
		}

		return inside;
	};
	
	p.toString = function()
	{
		return "[Polygon - points: " + this.points.join(",") + "]";
	};
	
	p.destroy = function()
	{
		this.edges = this.points = this.origin = this.aabb = null;
	};
	
	namespace('heist').Polygon = Polygon;
}());